import {
	colorsNew,
	ltGtMediaQuery, tertiaryColor,
} from 'root/src/client/web/commonStyles'

const Image = {
	imageContainer: {
		margin: [[12, 12, 12, 0]],
		minWidth: 60,
		width: 60,
		height: 60,
		borderRadius: 200,
		overflow: 'hidden',
		[ltGtMediaQuery]: {
			transform: 'translateX(0)',
			margin: [[10, 16, 10, 0]],
			width: 40,
			height: 40,
			minWidth: 40,
			minHeight: 40,
		},
	},
	image: {
		width: '100%',
		height: '100%',
		margin: 0,
		backgroundSize: 'contain',
	},
}
export const listStyle = {
	bottomLineWrapper: {
		margin: [[0, 0, 60, 0]],
		width: '100%',
	},
	showMoreContainer: {
		width: 54,
		height: 54,
		borderRadius: 200,
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	showMoreButton: {
		outline: 'none',
		cursor: 'pointer',
		display: 'block',
		padding: 0,
		backgroundColor: 'transparent',
		border: 'none',
	},
	noCommentsStab: {
		margin: 50,
		fontSize: 18,
	},
	center: {
		alignItems: 'center',
		marginTop: '10px !important',
	},
	...Image,
	signInPrompt: {
		marginLeft: 10,
	},
}

export const commentStyle = {
	root: {
		display: 'flex',
		minHeight: 141,
		padding: [[8, 0, 14]],
		'&:not(:last-of-type)': {
			borderBottom: `2px solid ${colorsNew.dark2}`,
		},
		[ltGtMediaQuery]: {
			alignSelf: 'flex-start',
			width: '100%',
			padding: [[0, 12]],
		},
	},
	commentWrapper: {
		width: '100%',
		'@media(max-width: 380px)': {
			paddingRight: 20,
		},
	},
	...Image,
	comment: {
		maxWidth: 559,
		wordWrap: 'break-word',
		fontSize: 14,
		lineHeight: '24px',
		letterSpacing: '0.1px',
		fontWeight: 400,
		[ltGtMediaQuery]: {
			width: 'initial',
		},
	},
	userMeta: {
		fontSize: 16,
		margin: [[16, 0, 8]],
	},
	bolder: {
		fontWeight: 'bolder',
	},
	metaText: {
		color: tertiaryColor,
		margin: [[0, 0, 0, 8]],
	},
	commentActions: {
		display: 'flex',
		flexWrap: 'wrap',
		[ltGtMediaQuery]: {
			width: 220,
		},
	},
	commentAction: {
		display: 'flex',
		alignItems: 'center',
		color: tertiaryColor,
		cursor: 'pointer',
		border: 'none',
		backgroundColor: 'transparent',
		fontSize: 16,
		padding: 0,
		outline: 'none',
		margin: [[10, 32, 0, 0]],
		'& > svg': {
			fill: tertiaryColor,
		},
	},
	commentActionHover: {
		'&:hover > svg': {
			fill: '#aaa',
		},
	},
	likeActionActive: {
		color: '#fff',
		'& > svg, &:hover > svg': {
			fill: '#fff',
		},
	},
	likeItemCount: {
		display: 'inline-block',
		marginLeft: 8,
		color: tertiaryColor,
	},
	viewMoreButton: {
		backgroundColor: 'transparent',
		cursor: 'pointer',
		border: 'none',
		outline: 'none',
		display: 'flex',
		alignItems: 'center',
		padding: 0,
	},
	viewMoreIcon: {
		transition: '.3s',
	},
	viewMoreIconOpen: {
		transform: 'rotateX(180deg)',
	},
	signInPrompt: {
		marginTop: 10,
	},
}
